module.exports = __webpack_public_path__ + "img/AFMS_OVERSPEED.566a0fcb.png";